import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpinnerButtonComponent} from './spinner-button.component';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
    exports: [SpinnerButtonComponent],
    declarations: [SpinnerButtonComponent]
})
export class SpinnerButtonModule {
}
